import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { NavigationService } from '@core/services/navigation/navigation.service';
import { NotificationControlService } from '@modules/notifications/application/notification-control/notification-control.service';
import { catchError, throwError } from 'rxjs';
import { SKIP_403_HANDLING } from './error-context';

let handling403 = false;

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const navigationService = inject(NavigationService);
  const notificationService = inject(NotificationControlService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 403 && !req.context.get(SKIP_403_HANDLING) && !handling403) {
        handling403 = true;

        notificationService.launchNotification(
          'Acceso denegado',
          'No tienes acceso a este recurso.',
          4000,
          'error',
        );

        navigationService.goBackOrFallback('/home');

        setTimeout(() => (handling403 = false), 5000);
      }

      return throwError(() => error);
    }),
  );
};
